import { gql } from '@apollo/client';

export const GET_V2_PROFILES = gql(/* GraphQL */ `
  query getProfileListV2($filters: ListProfilesFilters!, $pagination: ListProfilesPagination!) {
    listProfiles(filters: $filters, pagination: $pagination) {
      email
      firstName
      lastName
      lastSeen
      phone
      emailOptIn
      firstSeen
    }
  }
`);
